import { AbsurdIpfError } from '@ipfabric/frontend-shared-assets/utils/IpfError';
import {
  type EdgeAttribute,
  type PathLookupEdgeSettings,
  type TopologyEdgeSettings,
  isPathLookupEdgeSettings,
  isTopologyEdgeSettings,
  pathLookupEdgeAttributes,
  protocolEdgeAttributes,
} from '@ipfabric/utils';

export const getEdgeAttribute = (
  edgeSettings: TopologyEdgeSettings | PathLookupEdgeSettings,
): EdgeAttribute => {
  if (isTopologyEdgeSettings(edgeSettings)) {
    return protocolEdgeAttributes[edgeSettings.name];
  }
  if (isPathLookupEdgeSettings(edgeSettings)) {
    return pathLookupEdgeAttributes[edgeSettings.name];
  }
  throw new AbsurdIpfError(
    edgeSettings,
    'Unknown edge settings type to provide attributes for',
  );
};
